module.exports = __webpack_public_path__ + "static/media/Agri-Investors Infographic Desktop - GBR Network - 30-05-2024 N.e2ac9169.gif";